"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderExtended = exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _utilCrypto = require("@plugnet/util-crypto");

var _Compact = _interopRequireDefault(require("../codec/Compact"));

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _BlockNumber = _interopRequireDefault(require("./BlockNumber"));

var _Digest = _interopRequireDefault(require("./Digest"));

var _Hash = _interopRequireDefault(require("./Hash"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name Header
 * @description
 * A [[Block]] header
 */
class Header extends _Struct.default {
  constructor(value) {
    super({
      parentHash: _Hash.default,
      number: _Compact.default.with(_BlockNumber.default),
      stateRoot: _Hash.default,
      extrinsicsRoot: _Hash.default,
      digest: _Digest.default
    }, value || {});
  }
  /**
   * @description The wrapped [[BlockNumber]]
   */


  get blockNumber() {
    return this.get('number').toBn();
  }
  /**
   * @description The wrapped [[Digest]]
   */


  get digest() {
    return this.get('digest');
  }
  /**
   * @description The wrapped extrisics root as a [[Hash]]
   */


  get extrinsicsRoot() {
    return this.get('extrinsicsRoot');
  }
  /**
   * @description Convenience method, encodes the header and calculates the [[Hash]]
   */


  get hash() {
    return new _Hash.default((0, _utilCrypto.blake2AsU8a)(this.toU8a(), 256));
  }
  /**
   * @description Alias for `blockNumber` (this is displayed in JSON)
   */


  get number() {
    return this.blockNumber;
  }
  /**
   * @description The wrapped parent as a [[Hash]]
   */


  get parentHash() {
    return this.get('parentHash');
  }
  /**
   * @description The wrapped state root as a [[Hash]]
   */


  get stateRoot() {
    return this.get('stateRoot');
  }

}
/**
 * @name HeaderExtended
 * @description
 * A [[Block]] header with an additional `author` field that indicates the block author
 */


exports.default = Header;

class HeaderExtended extends Header {
  constructor() {
    let header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let sessionValidators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    super(header);
    this._author = void 0;

    if (!header || !header.digest || !sessionValidators.length) {
      return;
    }

    let item = header.digest.logs.find(log => log.isConsensus);
    let slot; // extract author from the consensus (substrate 1.0, digest)

    if (item) {
      const consensus = item.asConsensus;

      if (consensus.isAura) {
        slot = consensus.asAura[0];
      }
    } else {
      item = header.digest.logs.find(log => log.isSeal); // extract author from the seal (pre substrate 1.0, backwards compat)

      if (item) {
        slot = item.asSeal.slot;
      }
    } // found a slot? Great, extract the validator


    if (slot) {
      this._author = sessionValidators[slot.toNumber() % sessionValidators.length];
    }
  }
  /**
   * @description Convenience method, returns the author for the block
   */


  get author() {
    return this._author;
  }
  /**
   * @description Creates the JSON representation
   */


  toJSON() {
    return (0, _objectSpread2.default)({}, super.toJSON(), {
      author: this.author ? this.author.toJSON() : undefined
    });
  }

}

exports.HeaderExtended = HeaderExtended;